@if (!this.trigger.physicalSampleChooserMode) {
    <div class="mb-8">
        <p-button
                (click)="openUpgradeFirmwareDialog()"
                icon="pi pi-angle-double-up"
                isAdmin
                label="Trigger Firmware Upgrade"
        ></p-button>
    </div>
}

@if (this.trigger.physicalSampleChooserMode && !this.trigger.manualSelectionMode) {
    <div class="border border-gray-300 dark:border-gray-700 p-4 mb-8 rounded-sm">
        <div class="flex flex-wrap items-center justify-between gap-4">
            <div>
                <p class="font-medium">
                    @if (this.trigger.loadingEligiblePhysicalSamples) {
                        Loading eligible samples for firmware {{ this.trigger.chosenSampleFirmwareRevision.releaseVersion }}...
                    } @else if (this.trigger.eligiblePhysicalSamplesForUpgrade.length === 0) {
                        {{ this.trigger.emptyEligibleSamplesMessage }}
                    } @else {
                        Ready to upgrade all {{ this.trigger.eligiblePhysicalSamplesForUpgrade.length }} eligible sample(s) to
                                firmware {{ this.trigger.chosenSampleFirmwareRevision.releaseVersion }}
                    }
                </p>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                    {{ this.trigger.targetStudios.length }} studio(s): {{ this.trigger.targetStudioNames }}
                </p>
            </div>
            <div class="flex gap-2">
                <p-button
                        (click)="cancelRolloutTrigger()"
                        class="p-button-text"
                        icon="pi pi-times"
                        isAdmin
                        label="Cancel"
                        severity="secondary"
                ></p-button>
                <p-button
                        (click)="enableManualSelection()"
                        class="p-button-text"
                        icon="pi pi-list-check"
                        isAdmin
                        label="Select Samples Manually"
                        severity="secondary"
                ></p-button>
                <p-button
                        (click)="triggerFirmwareUpgrade()"
                        [disabled]="this.trigger.upgradeFirmwareInProgress || this.trigger.loadingEligiblePhysicalSamples || this.trigger.chosenPhysicalSamples.length === 0"
                        icon="{{ this.trigger.upgradeFirmwareInProgress ? 'pi pi-spin pi-spinner' : 'pi pi-angle-double-up' }}"
                        isAdmin
                        label="{{ this.trigger.upgradeFirmwareInProgress ? 'Processing...' : 'Trigger Upgrade' }}"
                ></p-button>
            </div>
        </div>
    </div>
}

@if (this.trigger.physicalSampleChooserMode && this.trigger.manualSelectionMode) {
    <div class="border border-gray-300 dark:border-gray-700 p-4 mb-8 rounded-sm">
        <div class="flex flex-wrap items-center justify-between gap-4 mb-3">
            <p class="font-medium">
                Selected {{ this.trigger.chosenPhysicalSamples.length }}
                of {{ this.trigger.eligiblePhysicalSamplesForUpgrade.length }}
                eligible sample(s) for firmware {{ this.trigger.chosenSampleFirmwareRevision.releaseVersion }}
            </p>
            <div class="flex gap-2">
                <p-button
                        (click)="cancelRolloutTrigger()"
                        class="p-button-text"
                        icon="pi pi-times"
                        isAdmin
                        label="Cancel"
                        severity="secondary"
                ></p-button>
                <p-button
                        (click)="triggerFirmwareUpgrade()"
                        [disabled]="this.trigger.upgradeFirmwareInProgress || this.trigger.chosenPhysicalSamples.length === 0"
                        icon="{{ this.trigger.upgradeFirmwareInProgress ? 'pi pi-spin pi-spinner' : 'pi pi-angle-double-up' }}"
                        isAdmin
                        label="{{ this.trigger.upgradeFirmwareInProgress ? 'Processing...' : 'Trigger Upgrade' }}"
                ></p-button>
            </div>
        </div>
        <p-table
                [(selection)]="this.trigger.chosenPhysicalSamples"
                [loading]="this.trigger.loadingEligiblePhysicalSamples"
                [paginator]="true"
                [rowsPerPageOptions]="[10, 20, 50]"
                [rows]="10"
                [value]="this.trigger.eligiblePhysicalSamplesForUpgrade"
                dataKey="macAddress"
                selectionMode="multiple"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th>MAC Address</th>
                    <th>Studio</th>
                    <th>Firmware Version</th>
                    <th>State</th>
                </tr>
            </ng-template>
            <ng-template let-physicalSample pTemplate="body">
                <tr>
                    <td>
                        <p-tableCheckbox [value]="physicalSample"></p-tableCheckbox>
                    </td>
                    <td>{{ physicalSample.macAddress }}</td>
                    <td>{{ physicalSample.studio?.name }}</td>
                    <td>{{ physicalSample.firmwareVersion || 'Unknown' }}</td>
                    <td>
                        <p-tag
                                [severity]="physicalSample.state === 'ONLINE' ? 'success'
                                    : physicalSample.state === 'OFFLINE' ? 'danger'
                                    : 'secondary'"
                                [value]="physicalSample.state ? (physicalSample.state | enumLabel) : 'Unknown'">
                        </p-tag>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td class="text-center text-gray-500 dark:text-gray-400" colspan="5">
                        {{ this.trigger.emptyEligibleSamplesMessage }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
}

<app-upgrade-physical-sample-firmware-dialog
        (choosePhysicalSampleForFirmwareUpgrade)="choosePhysicalSampleForFirmwareUpgrade($event)"
        [(visible)]="this.displayUpgradeFirmwareDialog"
        [allAvailableCountries]="this.allAvailableCountries"
        [allAvailableStudios]="this.allAvailableStudios"
></app-upgrade-physical-sample-firmware-dialog>
